import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Plus = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Plus({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.25 11.25V3.5C11.25 3.22386 11.4739 3 11.75 3H12.25C12.5261 3 12.75 3.22386 12.75 3.5V11.25H20.5C20.7761 11.25 21 11.4739 21 11.75V12.25C21 12.5261 20.7761 12.75 20.5 12.75H12.75V20.5C12.75 20.7761 12.5261 21 12.25 21H11.75C11.4739 21 11.25 20.7761 11.25 20.5V12.75H3.5C3.22386 12.75 3 12.5261 3 12.25V11.75C3 11.4739 3.22386 11.25 3.5 11.25H11.25Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'plus-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Plus;
